const Theme = {
  MINT: "MINT",
  SKY: "SKY",
  BLUE: "BLUE",
  PINK: "PINK"
}

type Theme = typeof Theme[keyof typeof Theme];

export default Theme;